import { WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { usePayoutSettings } from "../../../../query/payments/queries";
import { FormAddDebitCard } from "../../../../shared/components/FormAddDebitCard";
import { LayoutPaymentsSetup } from "../../../../shared/components/LayoutPaymentsSetup";
import { selectorInstantPayoutDefaultFee } from "../../../../shared/selectors/selectorInstantPayoutDefaultFee";
import { RouteComponentProps } from "../../types";

export const RouteInstantNewCard: React.FC<RouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();
  const queryPayoutSettings = usePayoutSettings(userId);

  return (
    <LayoutPaymentsSetup
      title="Connect your debit card for instant payouts"
      onBack={onBack}
    >
      <WSText mb="XL">
        Instantly receive funds to a supported debit card as soon as the funds
        are received. Income typically appear in the associated bank account
        within 30 minutes.
      </WSText>
      <WSText mb="XL">
        Instant payouts cost{" "}
        {selectorInstantPayoutDefaultFee(queryPayoutSettings.data)}% of the
        payout amount, with a minimum fee of $0.50.
      </WSText>
      <WSText>
        Most U.S. banks issue debit cards are compatible with Instant Payouts.
      </WSText>

      <FormAddDebitCard
        setInstantPayoutPreference
        updateInstantDestinaiton
        onSuccess={onNext}
      />
    </LayoutPaymentsSetup>
  );
};
